import e from "@dialpad/dialtone-tokens/layered/themes/tokens-124-colors.css?inline";
//#region themes/124.js
var t = { brand: {
	css: e,
	name: "124"
} };
//#endregion
export { t as default };
